import template from './location_distance.html'
import controller from './location_distance.controller'
import './location_distance.scss'

const locationDistanceComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default locationDistanceComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/location_distance/location_distance.component.js